import { createFileRoute, useParams } from "@tanstack/react-router";
import { PortalConnectorTypeContent } from "@/components/portal/PortalConnectorTypeContent";

export const Route = createFileRoute("/portal/connectors/$typeSlug/")({
  component: ConnectorTypePage,
});

function ConnectorTypePage() {
  const { typeSlug } = useParams({ from: "/portal/connectors/$typeSlug/" });
  return <PortalConnectorTypeContent typeSlug={typeSlug} />;
}
